import React, { useEffect, useState } from "react";
import "./ThemeSwitcher.css";

export default function ThemeSwitcher() {
  const [theme, setTheme] = useState(() => {
    try {
      const existing = document.documentElement.getAttribute("data-theme");
      if (existing === "dark" || existing === "light") {
        return existing;
      }
    } catch {
      // ignore and fall through
    }

    try {
      const saved = localStorage.getItem("theme");
      if (saved === "dark" || saved === "light") {
        return saved;
      }
    } catch {
      // ignore and fall through
    }

    // Fallback to light for first-time visitors
    return "light";
  });

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem("theme", theme);
    } catch {
      // ignore storage errors
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <button
      className="theme-switcher"
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      {theme === "dark" ? "\u2600\uFE0F" : "\uD83C\uDF19"}
    </button>
  );
}
